/**
 * TutorialsPanel Component
 *
 * Right-side panel listing tutorial video thumbnails. Extracted from
 * Dashboard.tsx as part of the Phase 0 refactor for the Projects feature.
 *
 * NOTE: This component is scheduled for removal in Phase 2 of the Projects
 * rollout. Tutorials will move to (a) the Iris empty-state CTA and (b) a
 * header "?" Help button. Keeping the file isolated makes that future
 * deletion a single-file change instead of a Dashboard.tsx edit.
 */

import React from 'react';

export interface TutorialVideo {
  id: string;
  title: string;
  description: string;
  youtubeId: string;
  thumbnail?: string;
}

export const DEFAULT_TUTORIAL_VIDEOS: TutorialVideo[] = [
  {
    id: 'getting-started',
    title: 'Text to Image',
    description: 'Start with a text prompt and generate your first AI image.',
    youtubeId: 'UrRxy4CzEj8',
  },
  {
    id: 'image-generation',
    title: 'Image to Image edit',
    description: 'Use nodes to edit and transform existing images with AI.',
    youtubeId: '8m15D7DoFdA',
  },
  {
    id: 'video-workflows',
    title: 'Two Images to Image',
    description: 'Combine multiple image inputs to generate a single composed image.',
    youtubeId: 'qLwLtHR6_EA',
  },
  {
    id: 'advanced-workflows',
    title: 'Image to Image - Improve Prompt',
    description: 'Use Improve Prompt to generate better prompts from your context, assets and model.',
    youtubeId: 'rYfqojOuREE',
  },
];

export interface TutorialsPanelProps {
  videos?: TutorialVideo[];
  onSelectVideo: (video: TutorialVideo) => void;
}

export const TutorialsPanel: React.FC<TutorialsPanelProps> = ({
  videos = DEFAULT_TUTORIAL_VIDEOS,
  onSelectVideo,
}) => {
  return (
    <div className="dashboard-sidebar-wrapper">
      <aside className="dashboard-sidebar">
        {/* Section Title */}
        <div className="dashboard-tabs">
          <span className="dashboard-tab active">TUTORIALS</span>
        </div>

        {/* Tab Content */}
        <div className="dashboard-tab-content">
          <div className="dashboard-tutorials-grid">
            {videos.map((video) => (
              <button
                key={video.id}
                className="dashboard-tutorial-card"
                onClick={() => onSelectVideo(video)}
              >
                <div className="tutorial-thumbnail">
                  <img
                    src={`https://img.youtube.com/vi/${video.youtubeId}/mqdefault.jpg`}
                    alt={video.title}
                  />
                  <div className="tutorial-play-overlay">▶</div>
                </div>
                <div className="tutorial-info">
                  <h4>{video.title}</h4>
                  <p>{video.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
};

export default TutorialsPanel;
